class NzrLoadoutSwitcher extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-loadout-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-loadout-panel]'));

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.activate(tab.dataset.loadoutTab));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });
  }

  activate(id, focus = false) {
    this.tabs.forEach((tab) => {
      const active = tab.dataset.loadoutTab === id;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;

      if (active && focus) tab.focus();
    });

    this.panels.forEach((panel) => {
      const active = panel.dataset.loadoutPanel === id;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
  }

  onKeydown(event, index) {
    if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;

    event.preventDefault();
    let nextIndex = index;

    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.tabs.length - 1;
    if (event.key === 'ArrowRight') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === 'ArrowLeft') nextIndex = (index + 1) % this.tabs.length;

    this.activate(this.tabs[nextIndex].dataset.loadoutTab, true);
  }
}

if (!customElements.get('nzr-loadout-switcher')) {
  customElements.define('nzr-loadout-switcher', NzrLoadoutSwitcher);
}
